import BsiIcon, { buttonIcon } from './BsiIcon';
import { MobileTitle } from './Shared';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { AuthRequired, PageHeading, Status, FileField, ErrorBox, ConfirmModal } from './Shared';
import { api, upload, t, text, record, money, date, vehicle, fileSize, errorText, currencies, defaultCurrency } from '../helpers';
import OrderProgress from './OrderProgress';
export default class OrderPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.id = m.route.param('id');
    this.order = null;
    this.comment = '';
    this.visibility = 'client';
    this.quoteComment = '';
    this.price = '';
    this.currency = defaultCurrency;
    this.result = null;
    app.setTitle(text('order.title', {
      number: this.id
    }));
    if (app.session.user) this.load();
  }
  load() {
    this.loading = true;
    this.error = null;
    return api('/orders/' + this.id).then(response => {
      this.order = record(response.data);
      this.price = this.order.quoted_amount == null ? '' : (this.order.quoted_amount / 100).toFixed(2);
      this.currency = this.order.quoted_amount == null ? defaultCurrency : this.order.quoted_currency;
      this.quoteComment = this.order.quote_terms || '';
    }).catch(error => {
      this.error = errorText(error);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, !app.session.user ? m(AuthRequired, null) : m("div", null, m("div", {
      className: "BsiBack"
    }, m(LinkButton, {
      className: "Button Button--link",
      href: app.route(this.order?.can_manage ? 'bsi.admin-orders' : 'bsi.orders'),
      icon: buttonIcon('arrow-left')
    }, t('nav.orders'))), m(ErrorBox, {
      error: this.error
    }), this.loading ? m(LoadingIndicator, {
      display: "block"
    }) : this.order && this.content())));
  }
  content() {
    const order = this.order;
    return m("div", null, m(PageHeading, {
      icon: "file-code",
      title: t('order.title', {
        number: order.id
      }),
      description: date(order.created_at)
    }, m(Status, {
      status: order.status
    }), m(Button, {
      className: "Button Button--link",
      icon: buttonIcon('arrows-clockwise'),
      disabled: this.busy,
      onclick: () => this.load()
    }, t('common.refresh'))), m(OrderProgress, {
      status: order.status
    }), m("div", {
      className: 'BsiOrderLayout BsiOrderLayout--' + order.status
    }, m("div", {
      className: "BsiOrderMain"
    }, this.files('result'), m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('order.details')), order.can_manage && order.user && m("div", {
      className: "BsiCustomer"
    }, m(BsiIcon, {
      name: "user-circle"
    }), m("div", null, m("small", null, t('orders.customer')), m("strong", null, order.user.display_name || order.user.username))), m("dl", {
      className: "BsiDetails"
    }, m("div", null, m("dt", null, t('orders.vehicle')), m("dd", null, vehicle(order))), m("div", null, m("dt", null, t('form.control_unit_type')), m("dd", null, order.control_unit_type || '—')), m("div", null, m("dt", null, t('form.control_unit_number')), m("dd", null, order.control_unit_number || '—'))), m("h3", null, t('form.requested_service')), m("p", {
      className: "BsiPreWrap"
    }, order.requested_service), order.comment && m("div", null, m("h3", null, t('form.comment')), m("p", {
      className: "BsiPreWrap"
    }, order.comment))), this.files(), order.can_manage && this.adminResult(), this.history(), order.can_manage && this.adminComment()), m("aside", {
      className: "BsiOrderAside"
    }, this.paymentPanel(), order.can_manage && this.adminManagement())));
  }
  files(type) {
    if (type === void 0) {
      type = 'original';
    }
    const result = type === 'result';
    // The API supplies only files this actor is allowed to see and download.
    const files = (this.order.files || []).filter(file => result ? file.type === 'result' : file.type !== 'result');
    if (result && !files.length) return null;
    const ready = this.order.status === 'COMPLETED';
    return m("section", {
      className: 'BsiPanel BsiFilesPanel BsiFilesPanel--' + type
    }, m("h2", null, m(BsiIcon, {
      name: result ? ready ? 'check' : 'file-code' : 'file-code'
    }), t(result ? ready ? 'files.results' : 'files.prepared' : 'files.originals')), result && m("p", {
      className: "helpText"
    }, t(ready ? 'files.completed_help' : 'admin.result_help')), files.map(file => m("a", {
      key: file.id,
      className: 'BsiFile BsiFile--' + type,
      href: file.download_url || app.forum.attribute('apiUrl') + '/bsi/files/' + file.id + '/download'
    }, m("span", {
      className: "BsiFile-emblem"
    }, m(BsiIcon, {
      name: result ? 'file-text' : 'file-code'
    })), m("span", {
      className: "BsiFile-info"
    }, m("strong", null, file.original_name), m("small", null, fileSize(file.size), " \xB7 ", date(file.created_at))), m("span", {
      className: 'BsiFile-action' + (result ? ' Button Button--primary' : '')
    }, m(BsiIcon, {
      name: "download-simple"
    }), t(result ? 'files.download_result' : 'files.download')))), !files.length && m("p", {
      className: "helpText"
    }, t('files.empty')));
  }
  paymentPanel() {
    const order = this.order;
    const manageable = order.can_manage;
    const paymentAvailable = app.forum.attribute('bsiPaymentAvailable');
    const paymentReview = (order.payments || []).some(payment => payment.status === 'REVIEW');
    const confirmed = ['PAID', 'IN_PROGRESS', 'COMPLETED'].includes(order.status);
    return m("section", {
      className: 'BsiPanel BsiQuotePanel BsiQuotePanel--' + order.status
    }, m("h2", null, m(BsiIcon, {
      name: "receipt"
    }), t('order.price')), m("div", {
      className: 'BsiPrice' + (order.quoted_amount == null ? ' BsiPrice--waiting' : '')
    }, order.quoted_amount == null ? t('order.price_waiting') : money(order.quoted_amount, order.quoted_currency)), order.quoted_amount != null && m("div", {
      className: "BsiQuoteTerms"
    }, m("h3", null, t('order.quote_terms')), m("p", {
      className: order.quote_terms ? 'BsiPreWrap' : 'helpText'
    }, order.quote_terms || t('order.quote_terms_missing'))), confirmed && m("div", {
      className: "BsiPaymentConfirmed"
    }, m(BsiIcon, {
      name: "shield-check"
    }), t('payment.confirmed')), m("p", {
      className: "helpText"
    }, t('order.hint_' + order.status)), paymentReview && m("p", {
      className: "BsiPaymentNotice"
    }, t('payment.review')), !manageable && order.status === 'QUOTED' && m("div", null, !paymentAvailable && m("p", {
      className: "BsiPaymentNotice"
    }, t('payment.unavailable')), m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.busy === 'payment',
      disabled: !!this.busy || !paymentAvailable || paymentReview,
      icon: buttonIcon('lock-key'),
      onclick: () => this.startPayment()
    }, t('payment.accept_pay')), m(Button, {
      className: "Button Button--link Button--block",
      disabled: !!this.busy,
      onclick: () => this.decline()
    }, t('payment.decline'))), !manageable && order.status === 'NEW' && m(Button, {
      className: "Button Button--link Button--block",
      disabled: !!this.busy,
      onclick: () => this.decline()
    }, t('order.cancel')), !manageable && order.status === 'PAYMENT_PENDING' && m("div", null, m("p", {
      className: "helpText"
    }, t('payment.pending_help')), this.activePayment()?.redirect_url && m(Button, {
      className: "Button Button--primary Button--block",
      disabled: !!this.busy,
      onclick: () => window.location.assign(this.activePayment().redirect_url)
    }, t('payment.continue')), m(Button, {
      className: "Button Button--block",
      loading: this.busy === 'check',
      disabled: !!this.busy,
      onclick: () => this.checkPayment()
    }, t('payment.check'))));
  }
  activePayment() {
    return (this.order.payments || []).find(payment => ['CREATING', 'PENDING', 'REVIEW'].includes(payment.status));
  }
  async startPayment() {
    this.busy = 'payment';
    this.error = null;
    try {
      const response = await api('/orders/' + this.id + '/payment', {
        method: 'POST'
      });
      const payment = record(response.data);
      const url = payment?.redirect_url || response.redirect_url;
      if (url) window.location.assign(url);else {
        this.error = t('errors.payment_unconfirmed');
        await this.load();
      }
    } catch (error) {
      this.error = errorText(error);
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
  async checkPayment() {
    this.busy = 'check';
    this.error = null;
    try {
      const payment = this.activePayment();
      if (payment) await api('/payments/' + payment.id + '/refresh', {
        method: 'POST'
      });
      await this.load();
      if (this.order.status === 'PAYMENT_PENDING') this.error = t('errors.payment_unconfirmed');
    } catch (error) {
      this.error = errorText(error);
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
  decline() {
    app.modal.show(ConfirmModal, {
      title: t('order.cancel_title'),
      message: t('order.cancel_message'),
      confirm: t('order.cancel_confirm'),
      action: () => this.mutate(() => api('/orders/' + this.id, {
        method: 'PATCH',
        body: {
          data: {
            attributes: {
              action: 'decline'
            }
          }
        }
      }), 'action', true)
    });
  }
  adminManagement() {
    const order = this.order;
    const quotable = ['NEW', 'QUOTED'].includes(order.status);
    const transitions = {
      PAID: ['IN_PROGRESS'],
      IN_PROGRESS: ['COMPLETED'],
      NEW: ['CANCELLED'],
      QUOTED: ['CANCELLED']
    };
    return m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('admin.management')), quotable && m("form", {
      onsubmit: e => {
        e.preventDefault();
        this.saveQuote();
      }
    }, m("div", {
      className: "BsiQuoteFields"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-price"
    }, t('admin.quote_amount')), m("input", {
      className: "FormControl",
      id: "bsi-price",
      inputmode: "decimal",
      required: true,
      value: this.price,
      placeholder: text('admin.quote_placeholder'),
      oninput: e => this.price = e.target.value,
      disabled: !!this.busy
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-currency"
    }, t('admin.quote_currency')), m("select", {
      className: "FormControl",
      id: "bsi-currency",
      value: this.currency,
      disabled: !!this.busy,
      onchange: e => this.currency = e.target.value
    }, currencies.map(currency => m("option", {
      value: currency
    }, currency))))), m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-quote-comment"
    }, t('admin.quote_comment')), m("textarea", {
      className: "FormControl",
      id: "bsi-quote-comment",
      rows: "4",
      required: true,
      maxlength: "10000",
      value: this.quoteComment,
      oninput: e => this.quoteComment = e.target.value,
      disabled: !!this.busy,
      "aria-describedby": "bsi-quote-comment-help"
    }), m("p", {
      className: "helpText",
      id: "bsi-quote-comment-help"
    }, t('admin.quote_comment_help'))), m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      icon: buttonIcon('receipt'),
      loading: this.busy === 'quote',
      disabled: !!this.busy
    }, t(order.quoted_amount == null ? 'admin.quote_save' : 'admin.quote_update'))), order.status === 'PAYMENT_PENDING' && m("p", {
      className: "helpText"
    }, t('admin.quote_locked')), (transitions[order.status] || []).map(status => m(Button, {
      className: 'Button Button--block ' + (status === 'CANCELLED' ? 'Button--link' : 'Button--primary'),
      disabled: !!this.busy || status === 'COMPLETED' && !(order.files || []).some(file => file.type === 'result'),
      onclick: () => this.changeStatus(status)
    }, t('admin.action_' + status))), order.status === 'IN_PROGRESS' && !(order.files || []).some(file => file.type === 'result') && m("p", {
      className: "helpText"
    }, t('admin.result_required')));
  }
  saveQuote() {
    const normalized = this.price.trim().replace(',', '.');
    if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
      this.error = t('admin.invalid_amount');
      return;
    }
    const amount = Math.round(Number(normalized) * 100);
    if (amount <= 0 || !Number.isSafeInteger(amount)) {
      this.error = t('admin.invalid_amount');
      return;
    }
    if (!this.quoteComment.trim()) {
      this.error = t('admin.quote_terms_required');
      return;
    }
    this.mutate(() => api('/orders/' + this.id, {
      method: 'PATCH',
      body: {
        data: {
          attributes: {
            quoted_amount: amount,
            quoted_currency: this.currency,
            quote_comment: this.quoteComment.trim()
          }
        }
      }
    }), 'quote');
  }
  changeStatus(status) {
    app.modal.show(ConfirmModal, {
      title: t('admin.status_title'),
      message: t('admin.status_message', {
        status: text('status.' + status)
      }),
      action: () => this.mutate(() => api('/orders/' + this.id, {
        method: 'PATCH',
        body: {
          data: {
            attributes: {
              status
            }
          }
        }
      }), 'action', true)
    });
  }
  adminResult() {
    if (!['PAID', 'IN_PROGRESS'].includes(this.order.status)) return null;
    return m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('admin.result_title')), m("form", {
      onsubmit: e => {
        e.preventDefault();
        this.uploadResult();
      }
    }, m(FileField, {
      label: t('admin.result_file'),
      required: true,
      id: "bsi-result-file",
      file: this.result,
      disabled: !!this.busy,
      uploading: this.busy === 'result',
      progress: this.uploadProgress,
      onchange: file => this.result = file
    }), m("p", {
      className: "helpText"
    }, t('admin.result_help')), m(Button, {
      className: "Button",
      icon: buttonIcon('upload-simple'),
      type: "submit",
      loading: this.busy === 'result',
      disabled: !!this.busy || !this.result
    }, t('admin.result_upload'))));
  }
  uploadResult() {
    if (!this.result) return;
    this.uploadProgress = 0;
    const body = new FormData();
    body.append('file', this.result);
    body.append('type', 'result');
    this.mutate(() => upload('/orders/' + this.id + '/files', {
      body,
      onProgress: percent => this.uploadProgress = percent
    }), 'result').then(success => {
      if (success) this.result = null;
    });
  }
  adminComment() {
    return m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('admin.comment_title')), m("form", {
      onsubmit: e => {
        e.preventDefault();
        this.saveComment();
      }
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-comment"
    }, t('admin.comment_body')), m("textarea", {
      id: "bsi-comment",
      className: "FormControl",
      rows: "4",
      required: true,
      maxlength: "4000",
      value: this.comment,
      disabled: !!this.busy,
      oninput: e => this.comment = e.target.value
    })), m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "bsi-visibility"
    }, t('admin.comment_visibility')), m("select", {
      id: "bsi-visibility",
      className: "FormControl",
      value: this.visibility,
      disabled: !!this.busy,
      onchange: e => this.visibility = e.target.value
    }, m("option", {
      value: "client"
    }, t('admin.visibility_client')), m("option", {
      value: "internal"
    }, t('admin.visibility_internal')))), m(Button, {
      className: "Button",
      type: "submit",
      icon: buttonIcon('chat-circle-dots'),
      loading: this.busy === 'comment',
      disabled: !!this.busy || !this.comment.trim()
    }, t('admin.comment_save'))));
  }
  saveComment() {
    return this.mutate(() => api('/orders/' + this.id + '/comments', {
      method: 'POST',
      body: {
        data: {
          attributes: {
            body: this.comment.trim(),
            visibility: this.visibility
          }
        }
      }
    }), 'comment').then(success => {
      if (success) this.comment = '';
    });
  }
  history() {
    return m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('order.history')), m("ol", {
      className: "BsiTimeline"
    }, (this.order.events || []).map(event => m("li", {
      key: event.id
    }, m("div", {
      className: "BsiTimeline-heading"
    }, m("strong", null, t('events.' + event.event_type)), event.visibility === 'internal' && m("span", {
      className: "BsiInternal"
    }, t('admin.visibility_internal')), m("time", null, date(event.created_at))), event.actor_name && this.order.can_manage && m("small", null, event.actor_name), this.eventDetails(event)))));
  }
  eventDetails(event) {
    const data = event.metadata || {};
    return m("div", null, data.body && m("p", {
      className: "BsiPreWrap"
    }, data.body), data.comment && m("p", {
      className: "BsiPreWrap"
    }, data.comment), (data.amount != null || data.quoted_amount != null) && m("p", null, money(data.amount ?? data.quoted_amount, data.currency || data.quoted_currency || 'BYN')), (data.to || data.status) && m("p", null, m(Status, {
      status: data.to || data.status
    })), data.original_name && m("p", null, data.original_name));
  }
  async mutate(action, type, rethrow) {
    if (type === void 0) {
      type = 'action';
    }
    if (rethrow === void 0) {
      rethrow = false;
    }
    if (this.busy) return;
    this.busy = type;
    this.error = null;
    try {
      await action();
      await this.load();
      return true;
    } catch (error) {
      this.error = errorText(error);
      if (rethrow) throw this.error;
      return false;
    } finally {
      this.busy = false;
      m.redraw();
    }
  }
}
flarum.reg.add('bsi-orders', 'forum/components/OrderPage', OrderPage);